import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import { EditFAQ, EditUserStatus } from "../actions/admin";
import { getAllPlans } from "../actions/currency";
import toast from "react-hot-toast";
import { fromTwos } from "ethers";

const EditFaqModal = ({ show, handleClose, record, getFAQData }) => {



  const [formvalue, setFormvalue] = useState();
  const [errors, setErrors] = useState({});


  useEffect(() => {
    setFormvalue(record);
  }, [record]);


  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      let Formvalue = { ...formvalue, [name]: value };
      let error = { ...errors };
      error[`${name}`] = "";
      setFormvalue(Formvalue);
      setErrors(error);
    } catch (err) {
      console.log(err, "handleChange");
    }
  };

  const validation = (value) => {
    try {
      let error = { ...errors };
      if (isEmpty(value.question)) {
        error["question"] = "Field is required";
      } else {
        error["question"] = "";
      }
      if (isEmpty(value.answer)) {
        error["answer"] = "Field is required";
      } else {
        error["answer"] = "";
      }

      return error;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };

  const handleSubmit = async () => {
    try {
      let oj = {
        _id: record._id,
        question: formvalue.question,
        answer: formvalue.answer,
      };
      let isValidate = validation(oj);
      setErrors(isValidate);
      if (!ObjectIsempty(isValidate)) {
        return true;
      }
      let { status, message, result } = await EditFAQ(oj);
      if (status == "success") {
        toast.success(message);
        getFAQData()
        handleClose();
      } else {
        toast.error(message);
        getFAQData()
        handleClose();
      }
      handleClose();
      getFAQData()
    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };



  return (
    <>
      <Modal
        centered
        className="cmn_modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="cmn_modal_header d-flex justify-content-between align-items-center">
            <p className="cmn_modal_title">Edit Faq</p>
            <button
              className="cmn_modal_closer rounded-5"
              onClick={() => {
                handleClose();
              }}
            >
              <i class="fa-solid fa-xmark" />
            </button>
          </div>

          <div className="mt-4">

            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Question</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  placeholder="Enter Title"
                  className="rp_singleInput flex-grow-1"
                  name="question"
                  onChange={handleChange}
                  value={formvalue?.question}

                />
              </div>
            </div>

            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Answer</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <textarea
                  placeholder="Enter Content"
                  className="rp_singleInput flex-grow-1"
                  rows="4"
                  name="answer"
                  onChange={handleChange}
                  value={formvalue?.answer}

                />
              </div>
            </div>

            <button className="orange_small_primary mt-3"

              onClick={(e) => handleSubmit()}


            >Submit</button>



          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditFaqModal;
